import { IsApproachTypeOfParams } from 'pages/ValuationsAllocation/types';

const isApproachTypeOf = (params: IsApproachTypeOfParams) => {
  const { approach, type } = params;

  return approach?.approach_type === type;
};

export default isApproachTypeOf;
